import { __assign, __extends } from "tslib";
import React from 'react';
import PropTypes from 'prop-types';
var withDisableAutoMessages = function (ComponentToWrap) { var _a; return _a = /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        class_1.prototype.render = function () {
            var disableAutoMessages = this.context.disableAutoMessages;
            // `as P` can be removed once the following issue closes
            // https://github.com/Microsoft/TypeScript/issues/28884
            var injectedProps = __assign(__assign({}, this.props), { disableAutoMessages: disableAutoMessages });
            return React.createElement(ComponentToWrap, __assign({}, injectedProps));
        };
        return class_1;
    }(React.Component)),
    _a.contextTypes = {
        disableAutoMessages: PropTypes.bool,
    },
    _a; };
export default withDisableAutoMessages;
//# sourceMappingURL=withDisableAutoMessages.js.map